import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const SelectContainer = styled.div`
  ${mediaQueries.tablet} {
    max-width: 180px;
  }
`
